






















import { computed, defineComponent, PropType, toRef } from "@vue/composition-api";
import { CallStatus, isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useMessageView from "@/hooks/useMessageView";
import { $t } from "@/lib/i18nHelpers";
import { toTimePassed } from "@/lib/time";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "SystemMessageCall",
  components: { BaseIcon },
  props: {
    message: { type: Object as PropType<Message>, required: true },
    markAsSeen: { type: Boolean, required: true },
  },
  setup(props) {
    const { isOpponentMessage, hoursMinutes, fullTime } = useMessageView(toRef(props, "message"));

    const text = computed(() => {
      if (isCallMessageDetails(props.message.details)) {
        const status = props.message.details.status;
        if (status === CallStatus.ENDED) {
          return isOpponentMessage.value ? $t("Incoming call") : $t("Outgoing call");
        }
        if (isOpponentMessage.value) return $t("Missed call");
        if (status === CallStatus.CANCELLED) return $t("Canceled call");
        if (status === CallStatus.DECLINED) return $t("Declined call");
      }
      return "";
    });

    const callDuration = computed(() => {
      if (
        isCallMessageDetails(props.message.details) &&
        props.message.details.startTime &&
        props.message.details.endTime
      ) {
        const duration =
          new Date(props.message.details.endTime).getTime() - new Date(props.message.details.startTime).getTime();
        return toTimePassed(duration);
      }
      return "";
    });

    return { isOpponentMessage, hoursMinutes, fullTime, text, callDuration };
  },
});
